import { defineNuxtPlugin } from '~/.nuxt/imports';
import { useAlertStore } from '~/store/alert';

export default defineNuxtPlugin(({ provide }) => {
  const alertStore = useAlertStore();
  provide('notifier', {
    showMessage({ title = null, content = '', type = '', timeout = 5000 }) {
      alertStore.showMessage({ title, content, type, timeout });
    }
  });
});
